import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-validations',
    templateUrl: './admin-validations.component.html',
    styleUrls: ['./admin-validations.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminValidationsComponent {

}
